gsap.registerPlugin(ScrollTrigger) 

let tl = gsap.timeline({
    scrollTrigger: {
        trigger: '.hero-animation-section',
        start: 'top top',
        end: 'bottom bottom',
        scrub: true,
        pin: true
    }
})

tl.fromTo('.hero-animation-section .hero-animation h1', {x: "80%"}, {x: "0%"})

